import React from 'react';
import { LevelRewardInput } from '../../../../../../__gqltypes__';
import '../../../components/assets/Chip.css';
import { formatReward } from '../../../components/formatReward';

type Props = {
  reward?: LevelRewardInput;
  canDelete?: boolean;
  btnAction?: () => void;
  globalAction: () => void;
  isAdd?: boolean;
  outlined?: boolean;
  cost: number;
  buyLimit: number;
};

const ChipShopItem = ({ reward, isAdd = false, canDelete, outlined = false, btnAction, globalAction, cost, buyLimit }: Props) => (
  <div className={outlined ? 'chip chip-outlined px-3' : 'chip px-3'}>
    <span role="link" tabIndex={0} onClick={globalAction}>
      {isAdd ? 'Add a reward' : `${formatReward(reward)} ,_____[COST: ${cost}],_____[BUY LIMIT: ${buyLimit}]`}
    </span>

    {(isAdd || canDelete) && (
      <button type="button" className="button" onClick={btnAction}>
        {isAdd ? '+' : '×'}
      </button>
    )}
  </div>
);

export default ChipShopItem;
